import { ContactForm } from "components/JsonForm/theme/widgets/ApplicationContactsWidget/ContactForm";
import { PrimaryContactFormProps, ContactTypeCode } from "./types";
import { RequireContact } from "types/RequireContact";
import { getHiddenFieldsByContactType, getRequiredFieldsByContactType, ContactType } from "components/utils/contacts";

export const PrimaryContactForm = ({
    formData,
    errors,
    requirements,
    onCopyContact,
    onUseCustomerContact,
    onChange,
    onClearForm,
}: PrimaryContactFormProps) => {
    const requiredFields = getRequiredFieldsByContactType(requirements.requiredFields, ContactType.Primary);
    const hiddenFields = getHiddenFieldsByContactType(requirements.hiddenFields, ContactType.Primary);

    const hideContact = requirements.requirePrimaryContact === RequireContact.Hidden;
    if (hideContact) {
        return null;
    }

    return (
        <ContactForm
            idPrefix="primary-contact"
            formData={formData}
            requirements={requirements}
            requiredFields={requiredFields}
            hiddenFields={hiddenFields}
            errors={errors}
            onUseCustomerContact={onUseCustomerContact}
            onCopyContact={onCopyContact}
            onChange={onChange}
            onClearForm={onClearForm}
            contactType={ContactTypeCode.Primary}
        />
    );
};
